/**
 * description:
 * Links page — fetches the FASA Forms and Slides link lists from the API
 * and displays them as two tile grids below a hero header.
 */
import { useEffect, useState } from "react";
import { Box, CircularProgress } from "@mui/material";
import FASAFormPage from "./FormLayout";
import Section from "../mainPage/Section";
import { mustard } from "../../../styles.tsx";
import PageHero from "../../../utils/PageHero";
import linksHero from "../../../pictures/Hero/LinksHero.svg";

const SHOW_SLIDES = true;

function LinksPage() {
  const [formsData, setFormsData] = useState([]);
  const [slidesData, setSlidesData] = useState([]);

  const [loadingForms, setLoadingForms] = useState(true);
  const [loadingSlides, setLoadingSlides] = useState(true);

  // Fetch forms data
  useEffect(() => {
    fetch("https://nehr0pj0y1.execute-api.us-east-1.amazonaws.com/fasa-forms")
      .then((response) => response.json())
      .then((data) => {
        const sortedForms = data.sort((a, b) => a.position - b.position);
        setFormsData(sortedForms);
        setLoadingForms(false);
      })
      .catch((error) => {
        console.error(error);
        setLoadingForms(false);
      });
  }, []);

  // Fetch slides data
  useEffect(() => {
    fetch("https://nehr0pj0y1.execute-api.us-east-1.amazonaws.com/fasa-slides")
      .then((response) => response.json())
      .then((data) => {
        setSlidesData(data);
        setLoadingSlides(false);
      })
      .catch((error) => {
        console.error(error);
        setLoadingSlides(false);
      });
  }, []);

  // If any data is still loading, show a spinner.
  if (loadingForms || loadingSlides) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" }}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <>
      <PageHero
        image={linksHero}
        viewBoxWidth={1910}
        viewBoxHeight={368}
        cropHeight={368}
        bandColor="#F2C94C"
        accessibleTitle="FASA Links!"
        pt={{ xs: "78px", sm: "76px", md: "90px", lg: "100px" }}
        width={{ xs: "94vw", sm: "620px", md: "760px", lg: "1200px", xl: "1421px" }}
      />

      <Section text="Forms" />
      <Box sx={{ bgcolor: "primary.main", px: { xs: "20px", md: "48px" }, pt: "40px", pb: { xs: "48px", md: "80px" } }}>
        <Box sx={{ maxWidth: "1200px", mx: "auto" }}>
          <FASAFormPage forms={formsData} cardColor="background.default" textColor="primary.main" shadowColors={["#ad5d4e", mustard]} />
        </Box>
      </Box>

      {SHOW_SLIDES && (
        <>
          <Section text="Slides" bgcolor="background.default" color="primary.main" />
          <Box sx={{ bgcolor: "background.default", px: { xs: "20px", md: "48px" }, pt: "40px", pb: { xs: "48px", md: "80px" } }}>
            <Box sx={{ maxWidth: "1200px", mx: "auto" }}>
              <FASAFormPage forms={slidesData} cardColor="background.paper" textColor="primary.main" shadowColors={["#12201f", "#ad5d4e"]} />
            </Box>
          </Box>
        </>
      )}
    </>
  );
}

export default LinksPage;
